module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst cssClasses = [];\nif(config.bootstrapVersion){\ncssClasses.push('accordion')\n} else {\ncssClasses.push('noBootStrap')\n}\n%><div class=\"<%= cssClasses.join(' ') %>\">\n<section class=\"header\"><%\n// mainly used for headline at the moment\nif(config.headerTagFormMapping){\n%><%- include('tag', { formMapping: config.headerTagFormMapping }); %><%\n}\nif(config.addRelationshipElementButtonsFormMapping){\n%><%- include('../form/elements/buttons', { formMapping: config.addRelationshipElementButtonsFormMapping }) %><%\n}\n%></section><%\nif(config.headerDescriptionKey){\n%><p class=\"headerDescription\"><%- __(config.headerDescriptionKey) %></p><%\n}\n%><section class=\"elements\">\n<%- helpers.renderSection(); %>\n</section>\n<section class=\"footer\"><%\n// if(config.addRelationshipElementButtonsFormMapping){\n%><%#- include('../form/elements/buttons', { formMapping: config.addRelationshipElementButtonsFormMapping }) %><%\n// }\n%></section>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\accordion\\accordion.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const cssClasses = [];
if(config.bootstrapVersion){
cssClasses.push('accordion')
} else {
cssClasses.push('noBootStrap')
}

    ; __line = 8
    ; __append("<div class=\"")
    ; __append(escapeFn( cssClasses.join(' ') ))
    ; __append("\">\n<section class=\"header\">")
    ; __line = 9
    ; 
// mainly used for headline at the moment
if(config.headerTagFormMapping){

    ; __line = 12
    ; __append( include('tag', { formMapping: config.headerTagFormMapping }) )
    ; 
}
if(config.addRelationshipElementButtonsFormMapping){

    ; __line = 15
    ; __append( include('../form/elements/buttons', { formMapping: config.addRelationshipElementButtonsFormMapping }) )
    ; 
}

    ; __line = 17
    ; __append("</section>")
    ; 
if(config.headerDescriptionKey){

    ; __line = 19
    ; __append("<p class=\"headerDescription\">")
    ; __append( __(config.headerDescriptionKey) )
    ; __append("</p>")
    ; 
}

    ; __line = 21
    ; __append("<section class=\"elements\">\n")
    ; __line = 22
    ; __append( helpers.renderSection() )
    ; __append("\n</section>\n<section class=\"footer\">")
    ; __line = 24
    ; 
// if(config.addRelationshipElementButtonsFormMapping){

    ; __line = 26
    ; 
// }

    ; __line = 28
    ; __append("</section>\n</div>")
    ; __line = 29
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\accordion\accordion.ejs

}